import { openInNewTab } from '@/components/Functional/utils/openInNewTab'
import { Button, Dialog } from '@/components/UI'
import { IconGift } from '@tabler/icons-react'

type Props = {
  opened: boolean
  onClose: () => void
  /** 当選した賞品名 */
  prizeName?: string
  /** 表示モード: dlc=ダウンロード, ar=ARカメラ起動 */
  mode?: 'dlc' | 'ar'
  /** DLC コンテンツURL（mode=dlc かつ実コンテンツがある場合） */
  contentFile?: string | null
  /** DLC モックページURL（contentFile が未設定の場合に新タブで開く） */
  dlcMockUrl?: string
  onDownload?: () => void
  onArCameraStart?: () => void
  onConfirm?: () => void
}

/**
 * 特典獲得ダイアログ（DLC / AR_PHOTO 兼用）。
 * mode に応じてボタンラベルとアクションが変わる。
 */
export function DialogV2DlcAcquired({
  opened,
  onClose,
  prizeName,
  mode = 'dlc',
  contentFile,
  dlcMockUrl,
  onDownload,
  onArCameraStart,
  onConfirm,
}: Props) {
  const handlePrimaryAction = () => {
    if (mode === 'ar') {
      onArCameraStart?.()
    } else {
      const targetUrl = contentFile ?? dlcMockUrl
      if (targetUrl) {
        openInNewTab(targetUrl)
      }
      onDownload?.()
    }
  }

  const buttonLabel = mode === 'ar' ? 'ARカメラを起動する' : 'ダウンロードする'

  return (
    <Dialog selectorState={opened} closeFunc={onClose} title="特典獲得" compact>
      <div className="flex flex-col items-center gap-4 px-4 py-6">
        <IconGift size={56} className="text-main" aria-hidden="true" />
        <p className="text-center text-[20px] font-bold leading-[28px] text-black">特典を獲得しました！</p>
        {prizeName && (
          <p className="text-center text-[13px] leading-[20px] text-gray-600">「{prizeName}」を獲得しました。</p>
        )}
        <Button label={buttonLabel} variant="primary" size="md" fullWidth onClick={handlePrimaryAction} />
        {onConfirm && (
          <button
            type="button"
            className="flex h-[48px] w-full items-center justify-center rounded-[8px] border border-gray-300 text-[15px] font-bold text-gray-600"
            onClick={onConfirm}
          >
            後で行う
          </button>
        )}
      </div>
    </Dialog>
  )
}
